import { WithModal } from 'hocs/withModal';
import FormGenerateGCC from './GenerateGCC';

const FormGenerateGCCModal = WithModal(FormGenerateGCC);

export { FormGenerateGCCModal, FormGenerateGCC };
